import Dots from './Dots.js';
import { resolve } from './tokens.js';

/*
 * Preparing
 *
 * What the customer sees while the first reply is being built.
 *
 * It says what is happening and why it is worth waiting for. A bare spinner
 * here reads as a chat that has not loaded, and the natural response to a chat
 * that has not loaded is to start typing the whole problem again. The copy only
 * mentions their answers when the flow actually captured some.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Preparing = ({
  answered,
  tokens: raw
}) => {
  const tokens = resolve(raw);
  return /*#__PURE__*/_jsxs("div", {
    "aria-live": 'polite',
    role: 'status',
    style: {
      paddingTop: 4
    },
    children: [/*#__PURE__*/_jsx(Dots, {
      label: 'Preparing your conversation',
      tokens: tokens,
      tone: 'accent'
    }), /*#__PURE__*/_jsx("span", {
      style: {
        color: tokens.text,
        display: 'block',
        fontFamily: tokens.font,
        fontSize: 15,
        fontWeight: 600,
        marginBottom: 8,
        marginTop: 16
      },
      children: answered ? 'Reading through what you told us' : 'Getting GRACI ready'
    }), /*#__PURE__*/_jsx("p", {
      style: {
        color: tokens.subtext,
        fontFamily: tokens.font,
        fontSize: 14,
        lineHeight: 1.6,
        margin: 0
      },
      children: answered ? 'GRACI AI is going over your answers so the conversation can pick up where the questions left off. This may take a few seconds.' : 'GRACI AI is getting ready to help. This may take a few seconds.'
    })]
  });
};
export default Preparing;